import React from 'react';
import './ComingSoonAppSection.css';
import logo from '../Images/myapoti_logo_pot.png';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGooglePlay, faAppStoreIos } from '@fortawesome/free-brands-svg-icons';
import { faMobileAlt } from '@fortawesome/free-solid-svg-icons'; // added mobile icon


const ComingSoonAppSection = () => {
    return (
      <section className="coming-soon-section">
        <div className="app-section-content">
          <div className="mockup-container">
            <FontAwesomeIcon icon={faMobileAlt} className="app-mockup-icon" />
          </div>
  
          <div className="app-info">
            <h2>Download MyApoti App Now!</h2>
            <p>
              Access verified pharmacies, search for essential drugs, and enjoy peace of mind, all in one simple app.
            </p>
  
            <ul className="feature-list">
              <li>🔍 Search for drugs by name or category</li>
              <li>✅ Verified pharmacy listings near you</li>
              <li>🛒 Refill prescriptions and place orders easily</li>
              {/* <li>📦 Track order status and delivery</li> */}
            </ul>
  
           <div className="store-badges">
              <a
                href="https://play.google.com/store/apps/details?id=my_apoti.com"
                target="_blank"
                rel="noopener noreferrer"
                className="store-icon"
              >
                <FontAwesomeIcon icon={faGooglePlay} />
                <span>Google Play</span>
              </a>

              <a
                href="https://apps.apple.com/us/app/myapoti/id6754816268"
                target="_blank"
                rel="noopener noreferrer"
                className="store-icon"
              >
                <FontAwesomeIcon icon={faAppStoreIos} />
                <span>App Store</span>
              </a>
            </div>
          </div>
        </div>
      </section>
    );
  };
  
  export default ComingSoonAppSection;